<template>
  <div class="main_dom">
      <div class="main_left">
          <ul>
              <li v-for="(item,index) in tabList" :key="index" :class="{hot:tabIndex == index}" @click="tabIndex = index"> {{item}} </li>
          </ul>
      </div>
      <div class="main_right" v-show="tabIndex == 0">
        <h2>深圳市司法鉴定行业自律公约(修订版)</h2>
        <div v-if="conventionPage == 0">
          <div class="text_title">第一章 总则</div>
          <span>第一条 为规范司法鉴定执业行为，维护司法公正与行业秩序，提升司法鉴定公信力，保障司法鉴定机构（以下简称“鉴定机构”）的鉴定活动顺利开展，本公约由自愿加入的鉴定机构及司法鉴定人（以下简称“鉴定人”）共同制定，作为行业自律准则。</span>
          <span>第二条 司法鉴定工作坚持中国共产党的领导，落实从严治党和廉洁自律各项要求，加强司法鉴定行业党的建设，充分发挥党组织的战斗堡垒和党员的先锋模范作用，做到党建和业务工作深度融合、相互促进。</span>
          <span>第三条 本公约遵循“科学严谨、客观独立、公正诚信、合法合规”原则，补充法律法规监管，推动司法鉴定行业专业化、规范化发展。</span>
          <span>第四条 凡自愿签署本公约的鉴定机构及鉴定人，均应严格遵守公约约定，接受行业监督，接受司法行政部门指导。</span>
          <div class="text_title">第二章 职业道德准则</div>
          <span>第五条 坚守鉴定活动不受委托方、当事人、司法机关工作人员或其他利益相关方干预，不偏袒任何一方，确保鉴定结论基于科学事实与专业技术。</span>
          <span>第六条 恪守诚信底线，禁止伪造鉴定材料、篡改检测数据、出具虚假鉴定意见书；禁止以“保证特定鉴定结果”“疏通关系”等虚假承诺承接业务，杜绝误导司法裁判的行为。</span>
          <span>第七条 履行保密义务，不得泄露鉴定过程中获取的案件信息、当事人隐私、商业秘密及未公开的鉴定结论，法律法规或司法机关另有要求的除外。</span>
          <span>第八条 维护职业尊严，不从事与司法鉴定职责冲突的营利活动，禁止收受当事人财物、索要额外费用，不得利用执业便利谋取不正当利益。</span>
        </div>
        <div v-else-if="conventionPage == 1">
          <div class="text_title">第三章 业务操作规范</div>
          <span>第九条 严格遵循《司法鉴定程序通则》及领域专属技术标准（如法医类、物证类、声像资料类等），规范开展委托受理、样本采集、检验检测、结果分析等环节，确保流程可追溯、操作可复现。</span>
          <span>第十条 委托受理需审核材料合法性与完整性，对不符合要求（如材料来源不明、超出鉴定能力范围）的委托，应依法拒绝并说明理由；不得跨资质范围承接鉴定业务。</span>
          <span>第十一条 鉴定设备需符合鉴定方法要求并定期核查和维护，检测方法按照《司法鉴定程序通则》要求。对鉴定过程中出现的异常数据，需及时复核验证，不得擅自忽略或隐瞒。</span>
          <span>第十二条 鉴定意见书需内容完整、逻辑清晰，明确载明委托事项、鉴定材料、鉴定方法、检验结果、分析说明及鉴定结论等，由鉴定人签字并加盖鉴定机构司法鉴定专用章，确保文书合法有效。</span>
          <span>第十三条 建立鉴定档案管理制度，对委托协议、鉴定材料、检测记录、意见书等资料按照要求保存（有特殊规定的从其规定），保障后续查询、复核及司法监督需求。</span>
        </div>
        <div v-else-if="conventionPage == 2">
          <div class="text_title">第四章 行业竞争与合作</div>
          <span>第十四条 开展良性竞争，禁止以恶意低价、虚假宣传（如夸大鉴定资质、伪造案例成果）、诋毁同行声誉等方式争抢业务、扰乱司法鉴定市场的正常秩序。对于政府定价项目严禁通过拆分鉴定服务项目达到提高收费的目的；参与鉴定服务项目竞价投标的，投标价不得低于政府定价的80%。发现外地鉴定机构低价投标的，应报告本协会。</span>
          <span>第十五条 鼓励行业技术交流与合作，支持参与专业培训、学术研讨及能力验证活动，共享合规的技术成果与标准规范，共同提升行业整体技术水平，增强行业创新能力，以新质生产力促进行业高质量发展。</span>
          <span>第十六条 当不同鉴定机构对同一事项的鉴定结论存在差异时，应配合司法机关或行业组织依法依规开展技术论证、重新鉴定，不得通过非专业或法定途径（如恶意投诉、舆论攻击）干扰争议解决。</span>
          <div class="text_title">第五章 监督与惩戒</div>
          <span>第十七条 成立行业纪律监督委员会（简称监督委员会），负责监督本公约执行情况，受理对违约行为的投诉与举报，组织调查核实，定期公示监督结果。</span>
          <span>第十八条 对违反本公约的鉴定机构及鉴定人，监督委员会根据情节轻重采取相应惩戒措施。</span>
          <span>第十九条 鉴定机构及鉴定人对惩戒结果有异议的，可在收到通知后15个工作日内进行申诉，监督委员会接到申诉后需在60个工作日内出具复核意见并答复。</span>
        </div>
        <div v-else-if="conventionPage == 3">
          <div class="text_title">第六章 附则</div>
          <span>第二十条 本公约经签署方（鉴定机构盖章、鉴定人签字）确认后生效，有效期3年，期满后经行业协商修订并重新签署。</span>
          <span>第二十一条 本公约未尽事宜，参照《中华人民共和国刑事诉讼法》《中华人民共和国民事诉讼法》及司法鉴定相关法律法规、部门规章执行；若与法律法规冲突，以法律法规为准。</span>
          <span>第二十二条 本公约由深圳市司法鉴定协会解释。</span>
        </div>
        <div class="text_button">
          <button type="submit" @click="skipConvention(1)">上一页</button>
          <button type="submit" @click="skipConvention(2)">下一页</button>
          <span>当前为第{{ conventionPage + 1 }}页/共4页</span>
        </div>
      </div>
      <div class="main_right" v-show="tabIndex == 1">
        <h2>深圳市司法鉴定行业诚信等级评估实施办法</h2>
        <div v-if="page == 0">
            <div class="text_title">
              第一章 总则
            </div>
            <span>第一条 为了完善深圳市司法鉴定诚信体系建设，增强司法鉴定机构和司法鉴定人诚信意识，规范司法鉴定执业行为，提升司法鉴定社会公信力，保障司法鉴定机构和司法鉴定人诚信等级评估工作规范开展，根据《全国人大常委会关于司法鉴定管理问题的决定》、《司法鉴定机构登记管理办法》、《司法鉴定人登记管理办法》、《司法鉴定职业道德基本规范》和《深圳经济特区行业协会条例》等规定，制定本办法。</span>
            <span>第二条 本办法所称诚信等级评定，是指市司法鉴定协会依照本办法的评定内容，对司法鉴定机构和司法鉴定人诚信执业状况进行评定，并确定相应等级的评价活动。</span>
            <span>第三条 经省司法厅审核登记的本市司法鉴定机构和司法鉴定人的诚信等级评定工作，适用本办法。</span>
            <span>第四条 司法鉴定诚信等级评定工作，坚持客观、公正、公开、行业内部评定与社会评价相结合的原则。</span>
            <span>第五条 深圳市司法鉴定协会在深圳市司法局的指导下开展对全市司法鉴定机构和司法鉴定人的诚信等级评定工作，负责职权范围内信用信息的采集、录入和管理。</span>
            <div class="text_title">
              第二章 诚信等级评定的内容、等级和标准
            </div>
            <span>第六条 司法鉴定机构和司法鉴定人诚信等级评定包括下列内容：</span>
            <span>（一）机构党建情况及贯彻落实党的路线方针政策情况；</span>
            <span>（二）遵守法律、法规、规章和规范性文件情况；</span>
            <span>（三）遵守职业道德和执业纪律情况；</span>
            <span>（四）执行司法鉴定程序、技术标准和操作规范情况；</span>
            <span>（五）职业技术能力情况；</span>
            <span>（六）行业惩戒情况；</span>
            <span>（七）党纪处分情况；</span>
            <span>（八）行政处罚和行政处理情况；</span>
            <span>（九）因违规执业行为承担民事责任情况；</span>
            <span>（十）被依法追究刑事责任情况；</span>
            <span>（十一）人民法院、人民检察院发出的司法建议书、检察建议书，公安机关等办案部门发出整改建议书、司法鉴定协会发出的行业自律整改书等情况；</span>
        </div>
        <div v-else-if="page == 1">
            <span>（十二）认证认可、能力验证情况；</span>
            <span>（十三）鉴定意见采信情况；</span>
            <span>（十四）出庭作证义务履行情况；</span>
            <span>（十五）鉴定质量、鉴定程序、鉴定标准执行的例行检查情况；</span>
            <span>（十六）表彰奖励情况；</span>
            <span>（十七）继续教育、针对性培训情况；</span>
            <span>（十八）年度执业考评情况；</span>
            <span>（十九）参加公益活动情况；</span>
            <span>（二十）法律援助情况；</span>
            <span>（二十一）其他诚信情况。</span>
            <span>第七条 司法鉴定机构和司法鉴定人诚信等级评定按照综合评估情况分为A、B、C 三个等级。</span>
            <span>第八条 诚信等级评定总分值为 100 分，诚信等级评定采用积分制。所得分值在 90 分以上的，确定为A 等级；所得分值在 75 分以上 89 分以下的， 确定为B 等级；所得分值在 60 分以上 74 分以下的，确定为C 等级；所得分值不满 60 分的，不予评定等级。</span>
            <span>诚信等级设置基础分30分，在此基础上根据加分扣分情形评估核算所得分值。</span>
            <span>第九条 司法鉴定机构和司法鉴定人有下列严重违法、违规、违纪、失信行为记录之一的，不予评定等级：</span>
            <span>（一）司法鉴定人被追究刑事责任的；</span>
            <span>（二）被司法行政机关处以停止执业行政处罚的；</span>
            <span>（三）以不正当手段取得行政许可，被予以撤销的;</span>
        </div>
        <div v-else-if="page == 2">
            <span>（四）被法院列为失信被执行人的；</span>
            <span>（五）司法鉴定人受到开除党籍党纪处分的；</span>
            <span>（六）有其他严重违反法律、法规等规定情形的。</span>
            <span>第十条 司法鉴定机构和司法鉴定人有下列情形的，在诚信等级评定中应当得分，无下列情形的不得分：</span>
            <span>（一）党组织健全并有效开展工作、无党纪处分的；（5分）</span>
            <span>（二）因执业活动获得行政机关或行业协会表彰奖励的；(5分)</span>
            <span>（三）通过CNAS实验室认可或CMA认证; （5分）</span>
            <span>（四）评定周期内无司法行政机关及协会发出整改通知书等情况；（5分）</span>
            <span>（五）参加能力验证活动，结果全部为“通过”且80％以上为“满意”的；（4分）</span>
            <span>（六）鉴定意见总采信率达60％以上（3分）；总采信率达90％以上；（5分）</span>
            <span>（七）有效投诉率小于3 ‰；（3分）</span>
            <span>（八）履行出庭作证义务；（3分）</span>
            <span>（九）设备配置满足鉴定工作需要、设备租赁和设备管理与事实一致、设备按计划校准或功能核查；（5分）</span>
            <span>（十）机构内鉴定技术人员来源正当，无不同地点执业；鉴定人员数量满足规定要求；鉴定人员专业技术能力满足其技术领域的能力要求（5分）</span>
            <span>（十一）无离职人员仍列入报告和原始记录中，人员变动记录明确；（5分）</span>
            <span>（十二）检验鉴定活动中使用现行有效的标准(方法)；（5分）</span>
            <span>（十三）检验鉴定原始记录完整且可以溯源；技术档案完整且可以重建鉴定模型的；（5分）</span>
        </div>
        <div v-else-if="page == 3">
            <span>（十四）报告中数据和信息与原始记录一致、报告和原始记录中数据和信息与事实一致；（5分）</span>
            <span>（十五）无同类案件检测数据相同(技术上不可能的)；（3分）</span>
            <span>（十六）无鉴定人员超执业范围鉴定、超执业范围签字；(5分)</span>
            <span>（十七）环境条件满足鉴定工作要求，内务管理良好，无严重偏离；（5分）</span>
            <span>（十八）内部质量控制数据与事实符合；（5分）</span>
            <span>（十九）机构无超执业范围的鉴定；（4分）</span>
            <span>（二十）积极参加法律援助的；（4分）</span>
            <span>（二十一）完成重特大案件检验鉴定且被采信的；（3分）</span>
            <span>（二十二）积极参加公益活动的；（3分）</span>
            <span>（二十三）其他应当加分的事项。（3分）</span>
            <span>第十一条 司法鉴定机构和司法鉴定人有下列情形之一的，在诚信等级评定中每项应当予以扣30 分,情节严重的应当予以扣 40 分：</span>
            <span>（一）受到停止执业外行政处罚的；</span>
            <span>（二）因违规执业受到行业协会惩戒的；</span>
            <span>（三）在接受投诉调查和配合行政机关开展行政复议、行政诉讼活动中隐瞒实情、提供虚假材料、作虚假陈述；</span>
            <span>（四）恶意诋毁同行的；</span>
            <span>（五）正式出具鉴定意见后无正当理由擅自撤回的；</span>
        </div>
        <div v-else-if="page == 4">
            <span>（六）经人民法院依法通知，无正当理由拒绝出庭，或者拒绝指派鉴定人出庭作证；</span>
            <span>（七）因违规执业承担民事责任的。</span>
            <span>司法鉴定人因失信行为扣分的，其所在司法鉴定机构按同一项目同时扣分；有多个司法鉴定人因同一失信行为扣分的，对其所在司法鉴定机构按此类项目扣一次分；有多个司法鉴定人因不同失信行为扣分的，对其所在司法鉴定机构按不同项目分别扣分。</span>
            <div class="text_title">
              第三章 诚信等级评定程序
            </div>
            <span>第十二条 司法鉴定机构应当按照本办法，及时将本机构及司法鉴定人诚信执业情况进行自查，并将自查情况报深圳市司法鉴定协会。</span>
            <span>第十三条 深圳市司法鉴定协会按照本办法，负责职权范围内司法鉴定机构和司法鉴定人信用信息的采集、建档，并对信息的真实性负责。</span>
            <span>第十四条 诚信等级评定由深圳市司法鉴定协会秘书处诚信评定委员会根据本办法的规定进行。</span>
            <span>第十五条 司法鉴定机构或司法鉴定人对诚信等级评定结果有异议的，应当自评定结果公布之日起 10 个工作日内，提供相关依据和证明材料向深圳市司法鉴定协会提出重新评定申请。</span>
            <span>第十六条 深圳市司法鉴定协会收到重新评定申请 15 个工作日内，应当进行重新核查评定。重新核查评定工作应在 20 个工作日内完成，并将重新核查评定结果于 10 个工作日内反馈至申请异议机构或司法鉴定人。</span>
            <span>第十七条 异议处理期间，深圳市司法鉴定协会可以暂停发布提出异议申请的司法鉴定机构或司法鉴定人的诚信等级评定结果。</span>
            <span>第十八条 信用等级评定每三年进行一次，期间每年进行一次诚信核查。</span>
        </div>
        <div v-else>
            <div class="text_title">
              第四章 诚信等级评定结果使用
            </div>
            <span>第十九条 深圳市司法鉴定协会应当根据司法鉴定机构和司法鉴定人诚信等级评定情况，建立诚信等级信用档案，诚信等级评定结果向社会公开。</span>
            <span>第二十条 诚信等级评定结果为 A 的司法鉴定机构和司法鉴定人，可优先被推荐参评表彰和奖励。</span>
            <span>第二十一条 对于不予评定等级的司法鉴定机构和司法鉴定人，应当纳入司法鉴定行业重点监管范围。</span>
            <div class="text_title">
              第五章 附则
            </div>
            <span>第二十二条 本办法由深圳市司法鉴定协会理事会负责解释。</span>
            <span>第二十三条 本办法自印发之日起施行。 </span>
        </div>
        <div class="text_button">
            <button type="submit" @click="skip(1)">上一页</button>
            <button type="submit" @click="skip(2)">下一页</button>
            <span>当前为第{{ page+1 }}页/共7页</span>
        </div>

      </div>
      <div class="main_right" v-show="tabIndex == 2">
          <h2>深圳市司法鉴定协会会员违规行为惩戒办法</h2>
           <div v-if="step == 0">
                <div class="text_title">
                    第一章 总则
                </div>
                <span>第一条 为了加强司法鉴定行业管理，维护司法鉴定执业秩序，保障会员依法执业权利，规范深圳市司法鉴定协会（下称本会）对违规会员的惩戒行为，根据《全国人民代表大会常务委员会关于司法鉴定管理问题的决定》、《司法鉴定机构登记管理办法》、《司法鉴定人登记管理办法》、《司法鉴定程序通则》和《深圳市司法鉴定协会章程》等，制定本办法。</span>
                <span>第二条 会员有违反司法鉴定行业管理法律、法规、规章、制度的行为，尚不需要司法行政机关予以行政处罚的，由司法鉴定协会（以下简称“本会”）实施行业惩戒。</span>
                <span>第三条 本会对会员实施行业惩戒，适用本办法。</span>
                <span>第四条 本会实施行业惩戒，应当遵循客观、公正、公开的原则，以事实为依据，以法律为准绳，严格执行本会的有关规定，坚持教育与惩戒相结合，保障法律、法规以及行业规范得以贯彻执行。</span>
                <span>实施行业惩戒应当与违规行为的性质、情节、后果以及社会影响程度相当。</span>
                <span>第五条 会员对本会做出的行业惩戒，享有陈述和申辩权利；对行业惩戒决定不服的，有权提起申诉。</span>
                <div class="text_title">
                    第二章 惩戒的种类与适用
                </div>
                <span>第六条 本会对会员违规行为作出的行业惩戒种类有：</span>
                <span>（一）训诫；</span>
                <span>（二）责令书面检讨；</span>
                <span>（三）通报批评；</span>
                <span>（四）责令限期整改；</span>
                <span>第七条 对同一违规行为，已被处理（含行政处罚、行业惩戒等，下同）的，本会不予受理。</span>
                <span>第八条 本会认为会员的违规行为涉及行政处罚的，及时将有关违法线索移送给司法行政机关。</span>
           </div>
           <div v-else-if="step == 1">
               <span>第九条 会员有下列行为之一，本会给予训诫、责令书面检讨、通报批评、责令限期整改：</span>
               <span>（一）捏造、散布虚假事实，损害、诋毁其他会员声誉的；</span>
               <span>（二）违反约定泄漏当事人的商业秘密或者个人隐私的；</span>
               <span>（三）接受委托后，无正当理由不向委托人提供约定的鉴定服务的；</span>
               <span>（四）未按规范出具司法鉴定文书的；</span>
               <span>（五）无正当理由不完成继续教育学时的；</span>
               <span>（六）未按档案管理规定保存档案的；</span>
               <span>（七）拒绝接受本会监督、检查，或提供虚假材料或者隐瞒重要事实、有其他弄虚作假行为的；</span>
               <span>（八）有其他违反行业管理法律、法规、规章的行为，行政机关决定不予处理的。</span>
               <div class="text_title">
                    第三章 惩戒的作出与实施
                </div>
                <span>第十条 惩戒决定经会长办公会研究决定后由会长签发，制作惩戒决定书。决定书应当载明下列事项：</span>
                <span>（一）被惩戒个人会员的姓名、性别、身份证号码、专业技术职称或者行业执业资格、执业类别、执业机构、执业证号码，或者单位会员的机构名称、机构住所、法定代表人或者机构负责人姓名、业务范围、许可证号码；</span>
                <span>（二）事实和证据；</span>
                <span>（三）惩戒决定；</span>
           </div>
           <div v-else-if="step == 2">
              <span>（四）申诉的权利；</span>
              <span>（五）作出决定的本会名称；</span>
              <span>（六）作出决定的日期。</span>
              <span>第十一条 决定书应当在签发后的七日内送达被惩戒会员。</span>
              <span>第十二条 处理投诉办公室及其工作人员应当严格遵守工作纪律，应当对处理决定表决评议情况保密。</span>
              <span>第十三条 案件办结后，工作人员应当按照档案工作要求整理卷宗，按要求存档。</span>
              <span>第十四条 惩戒决定按下列方式实施：</span>
              <span>（一）训诫：由本会组成三人训诫小组，在被惩戒会员所在执业场所或在本会召开会议，由主持训诫会议的工作人员宣读《惩戒决定书》后，小组成员对违规会员进行批评教育，并记录在案。</span>
              <span>训诫时，被惩戒会员必须在场。被惩戒的为单位会员的，该单位会员负责人或法定代表人必须在场。</span>
              <span>（二）责成书面检讨：由本会根据《惩戒决定书》规定的时限、方式责令违规会员向本会提交书面检讨。</span>
              <span>（三）通报批评，将《惩戒决定书》的内容向全体会员进行通报。</span>
              <span>（四）责令限期整改，由本会将《惩戒决定书》的内容向被惩戒会员宣布，向全体会员通报，责令其在规定时间内停止违规的执业行为；限期届满由本会核查，核查合格结果应当报本会备案。</span>
              <span>第十五条 对会员的惩戒决定，记入本会会员诚信档案。</span>
              <span>第十六条 本会依据本办法对其会员给予本办法规定的通报批评、责令限期整改的惩戒，将惩戒决定报送司法行政机关备案，并抄送广东省司法鉴定协会。</span>
            </div>
            <div v-else>
                <div class="text_title">
                    第四章 申诉
                </div>
                <span>第十七条 被惩戒会员不服的，可以在收到惩戒决定书之日起十五日内向理事会提起申诉，由秘书处办理。</span>
                <span>第十八条 本会理事会应当在收到被惩戒会员的书面申诉书后的六十日内作出审议决定。</span>
                <span>第十九条 本会理事会根据不同情况作出以下审议决定：</span>
                <span>（一）认为原惩戒决定认定事实清楚，适用依据正确，处理程序恰当的，维持原决定；</span>
                <span>（二）认为原惩戒决定在程序上存在不足的，责成处理投诉办公室进行补正；</span>
                <span>（三）认为原惩戒决定认定事实不清，或适用依据错误，或程序严重不适当的，撤销原来的惩戒决定，重新作出决定；认为原惩戒决定认定事实不成立的，作出不予惩戒的决定。</span>
                <span>第二十条 本会理事会作出审议决定，应当制作审议决定书，自送达之日起生效。</span>
                <div class="text_title">
                  第四章 附则
                </div>
                <span>第二十一条 本办法中“日”指工作日，以日计算期限的，从该日的次日起计算。</span>
                <span>第二十二条 本办法自印发之日起施行。</span>
                <span>第二十三条 本办法由深圳市司法鉴定协会负责解释。</span>
            </div>
           <div class="text_button">
            <button type="submit" @click="skipChange(1)">上一页</button>
            <button type="submit" @click="skipChange(2)">下一页</button>
            <span>当前为第{{ step+1 }}页/共4页</span>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
        tabIndex:0,
        tabList:[ "深圳市司法鉴定行业自律公约(修订版)" , "深圳市司法鉴定行业诚信等级评估实施办法", "深圳市司法鉴定协会会员违规行为惩戒办法" ],
        conventionPage: 0,
        page:0,
        step:0
    };
  },
  created() {},
  mounted() {},
  methods: {
    skipConvention(index) {
      const last = 3;
      if (index == 1) {
        if (this.conventionPage == 0) {
          return;
        }
        this.conventionPage -= 1;
      } else {
        if (this.conventionPage == last) {
          this.$message({
            message: '已经是最后一页了!',
            type: 'warning'
          });
        } else {
          this.conventionPage += 1;
        }
      }
    },
    skip(index) {
      if (index == 1) {
        if (this.page == 0) {
          return;
        } else {
          this.page -= 1;
        }
      } else {
        if (this.page == 6) {
          this.$message({
          message: '已经是最后一页了!',
          type: 'warning'
        });
        } else {
          this.page += 1;
        }
      }
    },
    skipChange(index) {
      if (index == 1) {
        if (this.step == 0) {
          return;
        } else {
          this.step -= 1;
        }
      } else {
        if (this.step == 3) {
          this.$message({
          message: '已经是最后一页了!',
          type: 'warning'
        });
        } else {
          this.step += 1;
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
.main_dom{
    width: 85%;
    margin: 0 auto;
    display: flex;
}

.main_left{
    width: 18%;
    margin-right: 40px;
    ul{
        li{
            display: inline-block;
            width: 100%;
            height: 70px;
            font-size: 16px;
            padding-top: 12px;
            padding-left: 20px;
            padding-right: 20px;
            background-color: #e4e4e4;
            margin-bottom: 10px;
            cursor: pointer;
        }
        .hot{
            color: #f2e0e0;
            background-color: #b82925;
        }
    }
}
.main_right{
    flex: 1;
    h2{
        margin: 20px 0 20px 0;
    }
    span{
        font-size: 16px;
        display: block;
        margin-bottom: 20px;
        line-height: 30px;
    }
    .text_title{
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 20px;
    }
    // .text_span{
    // }
    .text_button {
      margin-left: 36%;
      margin-top: 40px;
      button {
        margin-right: 20px;
        width: 100px;
        height: 40px;
        background-color: beige;
        border-radius: 6px;
        cursor: pointer;
      }
      button:hover{
        color: cornsilk;
        background-color: rgb(110, 104, 104);
      }
      span{
        display: inline-block;
      }
    }
}
</style>